export const STAGE = {
  OR: { label: "OR", name: "Requisition", color: "#F59E0B" },
  OQ: { label: "OQ", name: "Quote", color: "#F0323E" },
  OF: { label: "OF", name: "Order", color: "#8B5CF6" },
  OI: { label: "OI", name: "PO — Invoice", color: "#0EA5E9" },
  OX: { label: "OX", name: "PO — Receipt", color: "#10B981" },
  OS: { label: "OS", name: "PO — Ship", color: "#EC4899" },
  OJ: { label: "OJ", name: "PO — Journal", color: "#64748B" },
};

export const STAGE_ORDER = ["OR", "OQ", "OF", "OI", "OX", "OS", "OJ"];

export const AGING_COLORS = {
  "0-7": "#FDE68A",
  "8-14": "#F59E0B",
  "15-30": "#EF4444",
  "30+": "#7F1D1D",
};

export const fmtInt = (n) =>
  (n ?? 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const fmtQty = (n) =>
  (n ?? 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const fmtQtyCompact = (n) => {
  const v = n ?? 0;
  if (Math.abs(v) >= 1_000_000) return (v / 1_000_000).toFixed(1) + "M";
  if (Math.abs(v) >= 1_000) return (v / 1_000).toFixed(1) + "K";
  return v.toLocaleString("en-US", { maximumFractionDigits: 0 });
};

export const fmtMonth = (m) => {
  if (!m) return "";
  const [y, mo] = m.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(mo, 10) - 1]} '${y.slice(2)}`;
};

export const fmtPeriod = (key, period) => {
  if (!key) return "";
  if (period === "week") {
    const [y, w] = key.split("-W");
    return `W${w} '${y.slice(2)}`;
  }
  if (period === "quarter") {
    const [y, q] = key.split("-Q");
    return `Q${q} '${y.slice(2)}`;
  }
  return fmtMonth(key);
};

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const ageTone = (age) => {
  if (age === null || age === undefined) return "text-[#9CA3AF]";
  if (age > 30) return "text-red-600";
  if (age > 14) return "text-orange-600";
  if (age > 7) return "text-amber-600";
  return "text-emerald-600";
};
